import { defineEvent } from '../types/event';
export var MINICART_CHECKOUT_CLICK = defineEvent({
    platforms: [
        {
            name: 'Heap',
            alias: 'miniCartCheckoutClick'
        },
        {
            name: 'Optimizely',
            alias: 'Clicks_on_checkout_button - minicart'
        }
    ]
});
